import { createActions } from 'redux-actions';
import {
  PATIENT,
  FETCH_PATIENT_LIST,
  FETCH_PATIENT_DETAIL,
  UPDATE_PATIENT_INFO,
  UPDATE_PATIENT_DATA,
  FETCH_EXPORT_PDF,
} from '../constants/ActionTypes';
import ActionFactory from './ActionFactory';
import {
  PatientAPIConnectors,
  FileAPIConnectors,
} from '../api/index';
import {
  createAlert,
  createSuccessAlert,
} from './ActionCreators';
import i18n from '../config/i18n';

const plainActions = createActions(
  ...Object.values(ActionFactory(FETCH_PATIENT_LIST)),
  ...Object.values(ActionFactory(FETCH_PATIENT_DETAIL)),
  ...Object.values(ActionFactory(UPDATE_PATIENT_INFO)),
  ...Object.values(ActionFactory(UPDATE_PATIENT_DATA)),
  ...Object.values(ActionFactory(FETCH_EXPORT_PDF)),
  { prefix: PATIENT },
);

const thunkActions = {
  fetchPatientList: filters => (
    async (dispatch) => {
      try {
        dispatch(plainActions.fetchPatientListRequest());
        const result = await PatientAPIConnectors.getPatientList(filters);
        dispatch(plainActions.fetchPatientListSuccess(result));
        return true;
      } catch (err) {
        dispatch(plainActions.fetchPatientListFailure(err));
        createAlert(err);
        return true;
      }
    }
  ),
  fetchPatientDetail: id => (
    async (dispatch) => {
      try {
        dispatch(plainActions.fetchPatientDetailRequest());
        const patientDetail = await PatientAPIConnectors.getPatient(id);

        // Fetch prsigned url for patient avatar
        if (patientDetail.photos.length > 0) {
          let avatarUrl = '';
          const avatarUrlResult = await FileAPIConnectors.getPhotoDownloadURL(
            `medical-records/${patientDetail.id}/photos/${patientDetail.photos[patientDetail.photos.length - 1].id}`
          );

          // Filter out 404 error
          if (avatarUrlResult.message && avatarUrlResult.statusCode !== 404) {
            throw avatarUrlResult;
          } else {
            avatarUrl = avatarUrlResult;
          }
          patientDetail.avatarUrl = avatarUrl;
        }

        dispatch(plainActions.fetchPatientDetailSuccess(patientDetail));
        return true;
      } catch (err) {
        dispatch(plainActions.fetchPatientDetailFailure(err));
        return err;
      }
    }
  ),
  updatePatientInfo: (medicalRecord, medicalRecordId) => (
    async (dispatch) => {
      try {
        dispatch(plainActions.updatePatientInfoRequest());
        const result = await PatientAPIConnectors.updatePatient(medicalRecord, medicalRecordId);
        dispatch(plainActions.updatePatientInfoSuccess(result));
        return true;
      } catch (err) {
        dispatch(plainActions.updatePatientInfoFailure(err));
        dispatch(createAlert(err));
        return err;
      }
    }
  ),
  updatePatientData: (medicalRecord, medicalRecordId) => (
    async (dispatch) => {
      try {
        dispatch(plainActions.updatePatientDataRequest());
        const result = await PatientAPIConnectors.updatePatient(medicalRecord, medicalRecordId);
        dispatch(plainActions.updatePatientDataSuccess(result));
        return true;
      } catch (err) {
        dispatch(plainActions.updatePatientDataFailure(err));
        dispatch(createAlert(err));
        return err;
      }
    }
  ),
  fetchExportPDF: pdfId => (
    async (dispatch) => {
      try {
        dispatch(plainActions.fetchExportPDFRequest());
        await PatientAPIConnectors.getExportPDF(pdfId);
        dispatch(plainActions.fetchExportPDFSuccess());
        dispatch(createSuccessAlert(i18n.t('downloadPdf')));
        return true;
      } catch (err) {
        dispatch(plainActions.fetchExportPDFFailure(err));
        dispatch(createAlert(err));
      }
      return false;
    }
  ),
};

export default {
  ...plainActions,
  ...thunkActions,
};



// WEBPACK FOOTER //
// ./src/actions/PatientActionCreators.js